// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__23_jD","header":"MergedInvoice_header__3SNjI"};